import { makeStyles, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, Typography } from "@material-ui/core"
import React, { useState } from "react"
import { TabPanel } from "./App"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        height: '100%',
    },
    table: {
        maxWidth: 900,
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        maxHeight: '600px'
    },
}))

export const XronodiagrammaParadoteon = () => {
    const classes = useStyles()
    const [activeTab, setActiveTab] = useState(0)

    return (
        <React.Fragment>
            <Typography variant='h5'>Παραδοτέα</Typography>
            <div className={classes.root}>
                <Tabs orientation="vertical" variant="scrollable" value={activeTab} className={classes.tabs} onChange={(e, v) => setActiveTab(v)} >
                    <Tab label="Π1.1" />
                    <Tab label="Π1.2" />
                    <Tab label="Π2.1" />
                    <Tab label="Π2.2" />
                    <Tab label="Π3.1" />
                    <Tab label="Π3.2" />
                    <Tab label="Π3.3" />
                    <Tab label="Π3.4" />
                    <Tab label="Π3.5" />
                    <Tab label="Π3.6" />
                    <Tab label="Π4.1" />
                    <Tab label="Π4.2" />
                    <Tab label="Π4.3" />
                    <Tab label="Π5.1" />
                    <Tab label="Π5.2" />
                    <Tab label="Π5.3" />
                    <Tab label="Π5.4" />
                    <Tab label="Π6.1" />
                    <Tab label="Π6.2" />
                    <Tab label="Π6.3" />
                    <Tab label="Π6.4" />
                    <Tab label="Π7.1" />
                    <Tab label="Π7.2" />

                </Tabs>
                <TabPanel value={activeTab} index={0}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">Π1.1 – Αναφορά σχετικά με τα δείγματα ελαιολάδου, ελαιόκαρπου και φύλλων ελιάς που θα συλλεχθούν. Δημιουργία ηλεκτρονικού συστήματος καταγραφής και κωδικοποίησης για όλα τα δείγματα ελαιολάδου και βρώσιμης ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/3/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={1}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">Π1.2 – Αναφορά σχετικά με τα δείγματα ΠΟΠ & ΠΓΕ ελαιολάδου που θα παραχθούν. Ανάπτυξη πρωτοκόλλου με τις βέλτιστες συνθήκες ελαιοποίησης</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left"> ΜΕΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/3/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={2}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π2.1 – Αναφορά για την ανάπτυξη του πρωτοκόλλου γενετικής ταυτοποίησης των ελληνικών ποικιλιών ελιάς - Αναφορά για πολυμορφισμούς απλού νουκελοτιδίου και ανάπτυξη λειτουργικών δεικτών</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΕΚΕΤΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/3/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={3}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">Π2.2 – Αναφορά σχετικά με την ανάπτυξη της καταλληλότερης μεθοδολογίας για προσδιορισμό των κυριότερων δευτερογενών μεταβολιτών στα δείγματα των φύλλων ελιάς </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΤΦΧΦΠ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/3/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={4}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π3.1 – Έκθεση προσδιορισμού της ισοτοπικής ταυτότητας της ελληνικής ελιάς.</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">Δημόκριτος</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>


                <TabPanel value={activeTab} index={5}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">Π3.2 – Αναφορά σχετικά με την αποτύπωση της μικροβιακής ποικιλότητας (βακτήρια και ζύμες) των ελληνικών ποικιλιών ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΓΠΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={6}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π3.3 – Αναφορά σχετικά με την συλλογή ταυτοποιημένων μικροοργανισμών απομονωμένων από ελληνικές ελιές</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΓΠΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={7}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π3.4 – Αναφορά σχετικά με το μεταβολικό και τεχνολογικό δυναμικό μικροοργανισμών απομονωμένων από ελληνικές ελιές</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΓΠΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={8}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">Π3.5 – Αναφορά σχετικά με την εξέλιξη της μικροβιακής χλωρίδας στη ζύμωση ελιών ελληνικού και ισπανικού τύπου</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΓΠΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={9}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π3.6 – Αναφορά σχετικά με την ανάπτυξη της καταλληλότερης μεθοδολογίας για προσδιορισμό των κυριότερων δευτερογενών μεταβολιτών στα δείγματα της βρώσιμης ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΤΦΧΦΠ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={10}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π4.1 – Έκθεση σχετικά με την ανάπτυξη εξειδικευμένου πρωτοκόλλου παραγωγής ελαιολάδου</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΤΦΧΦΠ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={11}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π4.2 – Έκθεση σχετικά με την εφαρμογή αναλυτικών μεθοδολογιών LC-UV/ MS, NMR στα συλλεγμένα δείγματα ελαιολάδου</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΤΦΧΦΠ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={12}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π4.3 – Αναφορά σχετικά με τον προσδιορισμό των ποιοτικών και οργανοληπτικών χαρακτηριστικών στα συλλεγμένα δείγματα ελαιολάδου</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΧΤΤΧΕΚΠΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={13}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π5.1 – Έκθεση σχετικά με τον προσδιορισμό της ισοτοπικής ταυτότητας των δειγμάτων ελαιολάδου ανά γεωγραφική περιοχή</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">Δημόκριτος</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={14}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">  Π5.2 – Αναφορά για την ανάπτυξη του πρωτοκόλλου γενετικής ταυτοποίησης των ελληνικών ελαιολάδων</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΕΚΕΤΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={15}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π5.3 – Αναφορά για την ανάπτυξη του πρωτοκόλλου ταυτοποίησης πολυποικιλιακών ελαιολάδων</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΕΚΕΤΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={16}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π5.4 – Αναφορά για την ανάπτυξη του πρωτοκόλλου ταυτοποίησης νοθείας από ελαιόλαδα διαφορετικών ειδών</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΕΚΕΤΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={17}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">  Π6.1 – Αναφορά σχετικά με τη δημιουργία και εγκατάσταση ιδιωτικού πρωτοκόλλου ταυτοποίησης και διασφάλισης των ελληνικών ποικιλιών ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={18}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π6.2 – Αναφορά σχετικά με τη δημιουργία και εγκατάσταση ιδιωτικού πρωτοκόλλου διασφάλισης ποιότητας βρώσιμης ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={19}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">  Π6.3 – Αναφορά σχετικά με τη δημιουργία και εγκατάσταση ιδιωτικού πρωτοκόλλου τεκμηρίωσης ισχυρισμού υγείας σε ελαιόλαδα που πληρούν τα κριτήρια της EFSA</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={20}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π6.4 – Αναφορά σχετικά με τη δημιουργία και εγκατάσταση ιδιωτικού πρωτοκόλλου διασφάλισης ποιότητας ΠΟΠ & ΠΓΕ ελαιολάδων</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΜΕΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={21}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left"> Π7.1 – Αναφορά σχετικά με τη προβολή των πιστοποιημένων προϊόντων ελιάς και ελαιολάδου σε εμπορικές εκθέσεις του εξωτερικού</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={22}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Παραδοτέου </TableCell>
                                    <TableCell align="left">  Π7.2 – Αναφορά σχετικά με τη προβολή των πιστοποιημένων ΠΟΠ & ΠΓΕ ελαιολάδων σε εμπορικές εκθέσεις του εξωτερικού</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Είδος Παραδοτέου</TableCell>
                                    <TableCell align="left">Έκθεση</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΜΕΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Παράδοση (μήνας)</TableCell>
                                    <TableCell align="left"> 17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={activeTab} index={1}>

                </TabPanel>
            </div>

        </React.Fragment>
    )
}